export const CALENDAR_SELECTION_MODE = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
} as const;

export const WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

export type CalendarSelectionMode =
  (typeof CALENDAR_SELECTION_MODE)[keyof typeof CALENDAR_SELECTION_MODE];

export const CALENDAR_SELECT_VIEW = {
  DATE: 'date',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
} as const;

export type CalendarSelectView = (typeof CALENDAR_SELECT_VIEW)[keyof typeof CALENDAR_SELECT_VIEW];

export const CK_LOGIN_BY = {
  EMAIL: 1,
  PHONE: 0,
} as const;

export * from './translations';
export * from './breakpoints';
export * from './auth-status.constants';
export * from './routes.constants';
